/**
 * Read a build-time Vite variable the app cannot start without.
 *
 * Vite inlines `import.meta.env.VITE_*` when the bundle is built, so a value
 * that was missing then is missing for good — and the failure surfaces far
 * from its cause. An absent VITE_API_ENDPOINT used to reach SuperTokens as an
 * empty apiDomain, which threw "Please provide a valid domain name" from deep
 * inside the library before React mounted, leaving a blank page.
 *
 * @throws Error naming the variable, so the console says what to set.
 */
export const requireBuildEnv = (name, value) => {
    if (value)
        return value;
    throw new Error(`${name} was not set when this bundle was built, so the app cannot start. ` +
        `Locally, start it through doppler (see the start:*:local scripts in ` +
        `package.json); for a deploy, pass it as a --build-arg in ` +
        `.github/workflows/fly-deploy.yml.`);
};
